export default "__VITE_ASSET__4026e75b__"